import RouterConfig from "navigations/RouterConfig";

function App() {
  return (
    <>
      <div className="App">
        <RouterConfig />
      </div>
    </>
  );
}

export default App;
